import { useCallback, useState } from "react"
// components
import Button from "shared/components/Button"
// styles
import { SText, STitle } from "pages/auth/styles"
import { useTranslation } from "react-i18next"

type ExternalCertificateCheckoutModalProps = {
  onContinue: () => Promise<void>
}

const ExternalCertificateCheckoutModal = ({ onContinue }: ExternalCertificateCheckoutModalProps) => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)

  const handleContinue = useCallback(async () => {
    setIsLoading(true)
    await onContinue()
    setIsLoading(false)
  }, [onContinue])

  return (
    <div>
      <STitle>{t("test:externalCertificateCheckoutModal:title")}</STitle>
      <SText variant="h5">{t("test:externalCertificateCheckoutModal:text")}</SText>
      <Button
        type="button"
        color="secondary"
        fullWidth
        variant="contained"
        onClick={handleContinue}
        disabled={isLoading}
      >
        {t("test:externalCertificateCheckoutModal:continueButtonText")}
      </Button>
    </div>
  )
}

export default ExternalCertificateCheckoutModal
